import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config/api';

export default function TeacherCredentials({ teacher }) {
  const [credentials, setCredentials] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const reveal = async () => {
    if (credentials) { setCredentials(null); return; }
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_ENDPOINTS.TEACHERS}/${encodeURIComponent(teacher.id)}/credentials`, {
        credentials: 'include', cache: 'no-store'
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Unable to load teacher credentials.');
      setCredentials(data);
    } catch (error) { setError(error.message); }
    finally { setLoading(false); }
  };
  return <div className="p-3 bg-blue-50 rounded border border-blue-200">
    <h4 className="text-sm font-medium text-blue-800 mb-2">Login Credentials</h4>
    <div className="text-xs text-blue-700 space-y-2">
      <p className="break-all"><strong>Email:</strong> {credentials?.email || teacher.email}</p>
      <p><strong>Current password:</strong> <span className="block mt-1 font-mono text-sm break-all select-all">{credentials ? credentials.password : 'Hidden'}</span></p>
      {credentials && <p>{credentials.passwordChanged ? 'Password changed by teacher' : 'Temporary password / change pending'}
        {credentials.passwordChangedAt && `: ${new Date(credentials.passwordChangedAt).toLocaleString('en-NG', { timeZone: 'Africa/Lagos' })}`}</p>}
      <button type="button" disabled={loading} onClick={reveal} className="border border-blue-400 rounded px-3 py-2 text-blue-900 disabled:opacity-60">
        {loading ? 'Loading...' : credentials ? 'Hide password' : 'Show current password'}
      </button>
      {error && <p role="alert" className="text-red-700">{error}</p>}
    </div>
  </div>;
}
